@use "../../variables" as *;
@use "../../mixins" as *;

.product-item-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
  color: $grey;

  &:hover,
  &:focus{
    color: $grey;
  }

  .info {
    margin-top: 0.375rem;
    margin-right: 0.5rem;
    margin-left: 0.5rem;

    @include tablet {
      margin-left: 0;
    }

    &.editorial {
      .description {

        @include tablet {
          font-size: 1rem;
          line-height: 1.25rem;
          margin-bottom: 0.25rem;
        }
      }

      .price-container {
        @include tablet {
          font-size: 0.875rem;
          line-height: 0.875rem;
        }
      }
    }

    .description {
      position: relative;
      font-size: 1rem;
      line-height: 1.25rem;
      margin-bottom: 0.15rem;
      overflow: hidden;
      white-space: nowrap;

      &::after {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        content: '';
        background: linear-gradient(90deg, $white-transparent 0%, $white 75%);
        width: 25%;
        height: 100%;
      }

      @include tablet {
        font-size: 1.5rem;
        line-height: 1.75rem;
      }
    }

    .price-container {
      font-size: 0.875rem;
      line-height: 0.875rem;

      @include tablet {
        font-size: 1.125rem;
        line-height: 1.125rem;
      }

      .sale-container {
        display: flex;

        div {
          display: flex;
          flex-direction: column;
        }

        .original-price-container {
          border-left: 0.063rem solid $divider;
        }

        .original-price {
          text-decoration: line-through;
        }

        .sale-price, .sale-price-with-original-price {
          color: #e4172e;
        }

      }
    }

    .hide-container {
      display: none;
    }

    .additional-colors {
      font-size: 0.675rem;
      color: $grey-text-light;
      font-weight: 300;

      &.margin-bottom {
        margin-top: 0;
        margin-bottom: 1.25rem;
      }
    }

    &.columns-3, &.matching-products {
      .description {
        font-size: 0.875rem;
        line-height: 0.975rem;
        margin-bottom: 0.375rem;

        @include tablet {
          margin-bottom: 0.375rem;
          font-size: 1rem;
          line-height: 1.25rem;
        }
      }

      .price-container {
        font-size: 0.75rem;
        line-height: 0.75rem;

        @include tablet {
          font-size: 0.875rem;
          line-height: 0.875rem;
        }

        .sale-container {
          margin-bottom: 0.25rem;

          @include tablet {
            margin-bottom: 0;
          }

          .original-price-container {
            padding-left: 0.656rem;
            margin-left: 0.531rem;

            @include tablet {
              padding-left: 1.15rem;
              margin-left: 1.15rem;

              span:first-child {
                margin-bottom: 0.375rem;
              }
            }

            span:first-child {
              margin-bottom: 0.25rem;
            }
          }

          .sale-price-container {
            .original-price {
              margin-bottom: 0.25rem;
            }

            @include tablet {
              .original-price {
                margin-bottom: 0.375rem;
              }
            }

            .sale-price {
              margin: 0.125rem 0;

              @include tablet {
                margin: 0;
              }
            }
          }
        }

        .current-price-container {
          margin-bottom: 0.375rem;
          @include tablet {
            margin: 0;
          }

          .current-exchange-price {
            padding-left: 0.656rem;
            margin-left: 0.656rem;
            border-left: 0.063rem solid $divider;

            @include tablet {
              padding-left: 1.156rem;
              margin: 0 1.156rem 0 1.156rem;
            }
          }
        }
      }

      .additional-colors {

        @include tablet {
          margin-top: 0.313rem;
          font-size: 0.75rem;
        }

        &.margin-bottom {
          margin-top: 0;
          margin-bottom: 1.25rem;
        }
      }
    }
  }
}
